module.exports = "static/assets/2291f2138819385c9a5750130f254f90.mp3";